import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Grid,
    TextField,
} from '@material-ui/core';
import { InfluencerContext } from '../../ClassificationInfluencer/NewsContext';
import { CampaignModel } from '../../../Models/CampaignModel';
import InfluencerModelField from './InfluencerModelField';
import { AuthContext } from '../../Authentication/AuthContext';
import { InfluencersAuxiliarResponse } from '../../../Models/InfluencerAuxiliarModel';


type Props = {
    open: boolean;
    onClose: () => void;
    influencer: CampaignModel | undefined;
    filters: InfluencersAuxiliarResponse | undefined;
};
function formatDateTime(dateString?: string) {
    if (!dateString) return '';
    const date = new Date(dateString);
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

function formatDate(dateString?: string) {
    if (!dateString) return '';
    const date = new Date(dateString);
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;
}
export default function CampaignDetailModal({ open, onClose, influencer, filters }: Props) {
    const authContext = React.useContext(AuthContext);
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            PaperProps={{
                style: {
                    borderRadius: 12,
                    padding: '1rem',
                },
            }}
        >
            <DialogTitle disableTypography>
                <Typography variant="h6">Detalhe Campanha</Typography>
                <Typography variant="subtitle1">{influencer?.nome}</Typography>
            </DialogTitle>

            <DialogContent dividers style={{ paddingTop: 16, paddingBottom: 16 }}>
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Responsável Reputação" value={influencer?.responsavelReputacao} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Nome Solicitante" value={influencer?.solicitante} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="E-mail" value={influencer?.email} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Data" value={formatDateTime(influencer?.dataRecebimento)} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Marca" value={influencer?.marca} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Área" value={influencer?.area} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="VP" value={influencer?.vp} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Nome Campanha ou Projeto" value={influencer?.nome} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Objetivo/conceito da iniciativa" value={influencer?.objetivo} />
                    </Grid>

                    <Grid item xs={4}>
                        <InfluencerModelField
                            label="Canais de Divulgação"
                            value={
                                influencer?.canaisId
                                    ?.map((canal) =>
                                        filters?.canais.find((f) => f.id_aux === canal.id_aux)?.descricao
                                    )
                                    .filter(Boolean) // remove undefined
                                    .join(', ') // junta em uma string
                            }
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Público-alvo" value={influencer?.publicoAlvo} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Abrangência" value={influencer?.abrangencia} />
                    </Grid>
                    <Grid item xs={12}>
                        <InfluencerModelField label="Observações" value={influencer?.observacoes} multiline
                            minRows={5} />
                    </Grid>

                    <Grid item xs={12}>
                        <InfluencerModelField label="A campanha envolverá a contratação de figuras públicas ou embaixadores sugeridos?" value={influencer?.envolvimentoFiguraPublica ? 'Sim' : 'Não'} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Inicio Período da Campanha" value={formatDate(influencer?.periodoCampanha)} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Fim Período da Campanha" value={formatDate(influencer?.periodoCampanhaFim)} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Nível de Risco" value={influencer?.nivelRisco} />
                    </Grid>
                    <Grid item xs={12}>
                        <InfluencerModelField label="Análise Reputacional" value={influencer?.analiseReputacional}
                            multiline
                            minRows={5} />
                    </Grid>

                </Grid>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={onClose}
                    variant="contained"
                    color="primary"
                    style={{ borderRadius: 8, textTransform: 'none' }}
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog >
    );
}
